import type { Optional } from '@gov-nx/core/types/helpers.types';

type OnUnauthorizedHandler = () => void;

let handler: Optional<OnUnauthorizedHandler>;

export const setOnUnauthorizedHandler = (
	nextHandler: Optional<OnUnauthorizedHandler>
): void => {
	handler = nextHandler;
};

export const runOnUnauthorizedHandler = (): void => {
	handler?.();
};
